(function () {
  if (window.yeeseCartPaymentMessagingLoaded) return;
  window.yeeseCartPaymentMessagingLoaded = true;

  let paypalRetry;

  async function ensureKlarnaSdk() {
    if (document.getElementById('klarna-osm-script-tag')) return;

    try {
      const defaultDomain = window.Shopify?.shop || window.location.hostname;
      const storeUrl = new URL('https://skosm.klarna.com/app-blocks/v1/store');
      storeUrl.searchParams.set('defaultDomain', defaultDomain);
      if (window.location.hostname !== defaultDomain) {
        storeUrl.searchParams.set('customDomain', window.location.hostname);
      }

      const response = await fetch(storeUrl.toString());
      if (!response.ok) return;
      const store = await response.json();
      if (!store.client_id || document.getElementById('klarna-osm-script-tag')) return;

      const script = document.createElement('script');
      script.id = 'klarna-osm-script-tag';
      script.async = true;
      script.src = 'https://js.klarna.com/web-sdk/v1/klarna.js';
      script.dataset.clientId = store.client_id;
      script.dataset.environment = store.playground_active ? 'playground' : 'production';
      document.body.prepend(script);
    } catch (error) {
      // Provider messaging is optional and should never block the cart.
    }
  }

  async function refreshKlarna(root) {
    const container = root.querySelector?.('[data-cart-payment-messaging]');
    const placement = container?.querySelector('klarna-placement');
    if (!container || !placement) return;
    placement.setAttribute('data-purchase-amount', container.dataset.cartTotal);

    await ensureKlarnaSdk();

    if (window.KlarnaOnsiteService?.push) {
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    }
  }

  function renderPayPal(root, attempts) {
    const container = root.querySelector?.('[data-cart-payment-messaging]');
    const target = root.querySelector?.('[data-paypal-cart-message]');
    if (!container || !target) return;

    const amount = (Number(container.dataset.cartTotal || 0) / 100).toFixed(2);
    if (!amount || amount === '0.00') return;

    if (!window.paypal?.Messages) {
      if (attempts < 20) {
        window.clearTimeout(paypalRetry);
        paypalRetry = window.setTimeout(() => renderPayPal(document, attempts + 1), 500);
      }
      return;
    }

    if (target.dataset.renderedAmount === amount) return;
    target.replaceChildren();
    target.dataset.renderedAmount = amount;
    window.paypal.Messages({
      amount,
      style: {
        layout: 'text',
        logo: { type: 'inline' },
        text: { color: 'black', size: 13 }
      }
    }).render(target).catch(() => {
      delete target.dataset.renderedAmount;
    });
  }

  function refresh(root) {
    const scope = root?.querySelector ? root : document;
    refreshKlarna(scope);
    renderPayPal(scope, 0);
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('[data-yeese-product-klarna]')) {
      ensureKlarnaSdk();
    }
  });
  document.addEventListener('on:variant:change', () => {
    if (document.querySelector('[data-yeese-product-klarna]')) {
      ensureKlarnaSdk();
    }
  });
  document.addEventListener('on:cart-drawer:after-open', () => refresh(document));
  document.addEventListener('on:cart:after-merge', () => {
    if (document.querySelector('cart-drawer[aria-hidden="false"]')) {
      window.setTimeout(() => refresh(document), 50);
    }
  });
  document.addEventListener('shopify:section:load', () => refresh(document));
})();
